
import Navbar from '../Navbar/Navbar'
import './Header.css'
import { useEffect } from 'react'
import { gsap } from 'gsap'

function Header  ()  {
  useEffect(() => {
    gsap.from('.nav', {
      y: -20,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      clearProps: 'transform',
    })
  }, [])

  return (
    <header className='header center' id='top'>
      <Navbar />
    </header>
  )
}

export default Header
